import React, { Children, cloneElement } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@material-ui/core/InputAdornment'
import { TextInput } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'

export const VinFilter =
    (
        <TextInput resettable label='Search by VIN' source='vin'  parse={ v => v.toUpperCase() }
            InputProps={ {
                endAdornment: (
                    <InputAdornment position='end'>
                        <SearchIcon color='disabled' />
                    </InputAdornment>
                )
            } } alwaysOn />
    )

export const ListActionToolbar = withStyles({
    toolbar: {
        alignItems: 'center',
        display: 'flex'
    }
})(({ classes, children, ...props }) => (
    <div className={ classes.toolbar }>
        { Children.map(children, button => cloneElement(button, props)) }
    </div>
))

export const ListStyles = theme => ({
    title: {
        maxWidth: '20em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    hiddenOnSmallScreens: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    date: { fontStyle: 'italic' }
})